import {Component, inject, ChangeDetectionStrategy} from "@angular/core";
import {TallTrackCardComponent} from "../tall/tall-track-card.component";
import {DIALOG_DATA, DialogRef} from "@angular/cdk/dialog";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {faXmark} from "@fortawesome/pro-regular-svg-icons";
import {TrackDialogData} from "../../../../services/dialogs.service";

@Component({
  selector: 'track-card-dialog',
  templateUrl: 'track-card.dialog.html',
  imports: [
    TallTrackCardComponent,
    FaIconComponent
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true
})
export class TrackCardDialog {
  protected dialogRef = inject<DialogRef<string>>(DialogRef<string>);
  protected dialogData = inject(DIALOG_DATA) as TrackDialogData;

  protected readonly faXmark = faXmark;

  closeDialog = () => {
    this.dialogRef.close();
  }

}
